import { Link } from 'gatsby';
import React from 'react';
import { isEmpty } from 'lodash';

import CurrencySwitcher from '../../../../../components/Header/currencyswitcher/CurrencySwitcher';
import ShopProduct from '../../../../../components/Shop/ShopProduct';
import iconView from '../../../../../images/icon-view.svg';
import { formatTitle } from '../../../../../utils/shop';

const RelatedList = ({ totalShopData }) => {
  return (
    <div className="categories-shop bg-dark">
      <div className="wrapper">
        <div className="cat_watch-body-list">
          <div className="cat_watch-item">
            <div className="product-category">
              <div className="product-list columns d-flex">
                {!!totalShopData?.nodes &&
                  totalShopData?.nodes[0]?.data?.related_products?.map(({ product_id }, idx) => {
                    return (
                      !isEmpty(product_id) && (
                        <Link to={`/product/${formatTitle(product_id?.title)}`} className="cols cols-4 list-item">
                          <div
                            className="list-figure bgImage"
                            style={{ backgroundImage: `url(${product_id?.image?.src})` }}
                          >
                            <div className="btn btn-view">
                              <img src={iconView} alt="View Product" />
                            </div>
                          </div>

                          <div className="list-content" id="white-text">
                            <span className="list-title">{product_id?.title}</span>
                            <span className="list-price">
                              <CurrencySwitcher
                                price={parseFloat(product_id?.variants[0]?.price).toFixed(2)}
                                caller="related"
                              />
                            </span>
                          </div>
                        </Link>
                      )
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelatedList;
